import { externalApiClient } from 'api/apiClient'
import xmlApi from './xml'

export default function api() {
  const externalData = { apiClient: externalApiClient() }

  return {
    xml: xmlApi(externalData),
  }
}
